import { Component, Inject, Injectable, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { ElectricitySupplyById } from "src/app/models/ElectricitySupplyById";
import { GasSupplyById } from "src/app/models/GasSupplyById";
import { HistoryComparison } from "src/app/models/HistoryComparison";
import { SelfConsumtionSupplyById } from "src/app/models/SelfConsumptionSupplyById";
import { ServerResponse } from "src/app/models/ServerResponse";
import { ContractsService } from "src/app/services/contracts.service";
import { HistoryDialogComponent } from "../history-dialog/history-dialog.component";
import { BehaviorSubject, Subject, takeUntil } from "rxjs";
import { ISTabLayout } from "is-lib";
import { TranslateService } from "@ngx-translate/core";
import { IEconomicConditions } from "src/app/models/EconomicConditions";
import { IContractElectricitySupply } from "src/app/models/ElectricitySupply";
import { IContractNaturalGasSupply } from "src/app/models/NaturalGasSupply";
import { IContractSelfConsumptionSupply } from "src/app/models/SelfConsumptionSupply";

@Component({
    selector: 'equipments-view',
    templateUrl: './equipments-view.component.html',
    styleUrls: ['./equipments-view.component.scss']
})

export class EquipmentsViewComponent implements OnInit, OnDestroy {
    // Ends the translation stream subscription, which never completes on its own
    private readonly _destroy$ = new Subject<void>();

    selectedTab: number = 0;

    electricityEquipment!: IContractElectricitySupply;
    gasEquipment!: IContractNaturalGasSupply;
    selfConsumptionEquipment!: IContractSelfConsumptionSupply;

    electricityDetail!: ElectricitySupplyById;
    gasDetail!: GasSupplyById;
    selfConsumptionDetail!: SelfConsumtionSupplyById;

    historyDataSource: MatTableDataSource<History>;
    economicConditionsDataSource: MatTableDataSource<IEconomicConditions>;

    contractId!: string;
    displayedColumnsHistory: string[] = ['TYPE', 'MODIFICATION_DATE', 'MODIFICATION_BY'/*, 'ACTIONS'*/];
    displayedColumnsEconomicConditions: string[] = ['CONTRACTED_PRICE', 'START_DATE', 'END_DATE'/*, 'ACTIONS'*/];

    tabLayout$!: BehaviorSubject<ISTabLayout>; //object with tabs
    
    constructor(private _dialogRef: MatDialogRef<EquipmentsViewComponent>, @Inject(MAT_DIALOG_DATA) public data: { gasDetail: IContractNaturalGasSupply, electricityDetail: IContractElectricitySupply, selfConsumptionDetail: IContractSelfConsumptionSupply, contractId: string }, private _contractsService: ContractsService, private _dialog: MatDialog, private _translateService: TranslateService){
        this.electricityEquipment = data.electricityDetail;
        this.gasEquipment = data.gasDetail;
        this.selfConsumptionEquipment = data.selfConsumptionDetail;
        this.contractId = data.contractId;
        this.historyDataSource = new MatTableDataSource<History>();
        this.economicConditionsDataSource = new MatTableDataSource<IEconomicConditions>();

        if(this.electricityEquipment){
            this._contractsService.getContractElectricitySuppliesId(this.electricityEquipment.guidId, this.contractId).subscribe((res: ServerResponse<ElectricitySupplyById>) => {
                // this.equipmentsDetailDataSource.data = res.data;
                this.electricityDetail = res.data;
                this._contractsService.getContractElectricitySuppliesHistory(this.electricityEquipment.guidId, this.contractId).subscribe((res: ServerResponse<History[]>) => {
                    this.historyDataSource.data = res.data;
                });
                this.economicConditionsDataSource.data = res.data.economicConditions;
            });
        }
        else if(this.gasEquipment){
            this._contractsService.getContractNaturalGasSuppliesId(this.gasEquipment.guidId, this.contractId).subscribe((res: ServerResponse<GasSupplyById>) => {
                this.gasDetail = res.data;
                this._contractsService.getContractNaturalGasSuppliesHistory(this.gasEquipment.guidId, this.contractId).subscribe((res: ServerResponse<History[]>) => {
                    this.historyDataSource.data = res.data;
                });
                this.economicConditionsDataSource.data =  res.data.economicConditions;
            });
        }
        else if(this.selfConsumptionEquipment){
            this._contractsService.getContractSelfConsumptionSuppliesId(this.selfConsumptionEquipment.guidId, this.contractId).subscribe((res: ServerResponse<SelfConsumtionSupplyById>) => {
                this.selfConsumptionDetail = res.data;
                this._contractsService.getContractSelfConsumptionSuppliesHistory(this.selfConsumptionEquipment.guidId, this.contractId).subscribe((res: ServerResponse<History[]>) => {
                    this.historyDataSource.data = res.data;
                });
            });
        }

        let selectedMenu = 0;

        this._translateService.stream(['INFO', 'HISTORY']).pipe(takeUntil(this._destroy$)).subscribe((translations: any) => {
            this.tabLayout$ = new BehaviorSubject<ISTabLayout>({
                selectedMenu: selectedMenu,
                tabItems: [
                    { id: 0, label: translations.INFO },
                    { id: 1, label: translations.HISTORY }
                ],
                verticalLayout: false
            });
        });
    }

    onTabChange(selectedTab: number) {
        this.selectedTab = selectedTab;
    }
    
    historyClick(historyId: string) {
        // this._contractsService.getContractHistoryComparison(this.contractId, historyId)
        // .subscribe((res: ServerResponse<HistoryComparison>) => {
        //     let teste = res.data;
        //     this._dialog.open(HistoryDialogComponent, {
        //         width: '90vw', // 90% of the viewport width
        //         maxWidth: '800px', // Maximum width for larger screens
        //         height: '80vh', // 80% of the viewport height
        //         maxHeight: '400px', // Maximum height for larger screens
        //         panelClass: 'responsive-dialog', // Optional: Add a custom class for additional styling
        //         data: { contractId: this.contractId, historyId: historyId },
        //     })
        // });
    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }
}